import React from 'react';

import { IFullwidthHero20Fields } from '../../../../types/contentful';

import { getImageData } from '../../../utils/contentful';

import PrivacyPolicyDisclaimer from '../PrivacyPolicyDisclaimer';
import { Flexbox } from '../../Flexbox';
import { Box } from '../../Box';
import { Layout, Column, BlockContainer } from '../../Layout';
import CtaWidget from '../../CtaWidget';
import { VideoPlayer } from '../../VideoPlayer';

import {
  CTAText,
  MobileImage,
  RelativeBox,
  MobileVersion,
  MobileSubheadingText
} from '../styles';

export default function MobileView({
  mobileHeadingText,
  mobileSubheadingText,
  mobileSubheadingSize,
  mobileImage,
  privacyPolicyDisclaimer,
  displayPrivacyPolicyIcon,
  videoModule,
  mobileCta
}: IFullwidthHero20Fields) {
  return (
    <MobileVersion>
      <Column size={12}>
        <RelativeBox flex={1}>
          {videoModule?.fields?.vimeoId ? (
            <VideoPlayer {...videoModule?.fields} rounded={false} />
          ) : (
            <MobileImage
              {...getImageData(mobileImage)}
              heroImage={true}
              loading="eager"
              data-testid="fullwidth-hero-mobile-background"
            />
          )}
        </RelativeBox>
      </Column>

      <BlockContainer
        marginTop={{ 0: 'l' }}
        marginBottom="2xl"
        revealOnScroll={false}
      >
        <Layout>
          <Column size={{ 0: 11, tablet: 8 }}>
            <Flexbox
              flexDirection="column"
              margin={[0, 'auto']}
              justifyContent="center"
              alignItems="center"
            >
              <CTAText
                as="h1"
                fontWeight="h2"
                colour="defaultText"
                textAlign="center"
                data-testid="fullwidth-hero-headline-mobile"
                fontSize="h1_0"
              >
                {(mobileHeadingText ?? '').replace(/<br>/g, ' ')}
              </CTAText>
              <MobileSubheadingText
                as="h2"
                fontWeight="400"
                lineHeight="ml"
                colour="defaultText"
                textAlign="center"
                marginTop="m"
                data-testid="fullwidth-hero-subheading-mobile"
                mobileSubheadingSize={mobileSubheadingSize ?? '1.125'}
              >
                {mobileSubheadingText}
              </MobileSubheadingText>
              {mobileCta && (
                <CtaWidget
                  {...mobileCta?.fields}
                  id="mobile-nav-cta"
                  sysId={mobileCta?.sys?.contentType?.sys?.id}
                  module="Hero"
                  isMobile={true}
                />
              )}
              {privacyPolicyDisclaimer && (
                <Box marginTop="ml">
                  <PrivacyPolicyDisclaimer
                    privacyPolicyDisclaimer={privacyPolicyDisclaimer}
                    displayPrivacyPolicyIcon={displayPrivacyPolicyIcon}
                  />
                </Box>
              )}
            </Flexbox>
          </Column>
        </Layout>
      </BlockContainer>
    </MobileVersion>
  );
}
